import AntTabs, { type TabsProps } from "antd/lib/tabs";
import clsx from "clsx";

import styles from "./Tabs.module.css";

export type { TabsProps };

export const Tabs = ({ className, ...props }: TabsProps) => {
    return <AntTabs {...props} className={clsx(styles.tabs, className ?? "")} />;
};
